<div class="card m-2 text-center" role="region" aria-labelledby="footer-center">
    <div class="card-body d-flex justify-content-center" style="height: 200px; overflow: hidden;">
        <div *ngIf="topCenterLoading" class="row">
            <div class="col my-auto">
                <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
        </div>
        <div *ngIf="!topCenterLoading" class="align-self-center w-100 h-100" style="overflow: auto;">
            <div class="row w-100 m-0">
                <div class="col-6 my-auto">
                    <span class="dash-label text-uppercase">{{'ADMITS' | translate}}</span><br>
                    <span class="dash-small-numeric">{{eventSummary.get('Admission') | roundNumber}}</span>
                </div>
                <div class="col-6 my-auto">
                    <span class="dash-label text-uppercase">{{'DISCHARGES' | translate}}</span><br>
                    <span class="dash-small-numeric">{{eventSummary.get('Discharge') | roundNumber}}</span>
                </div>
            </div>
            <div class="row w-100 m-0" style="margin-top: 1.4rem !important;">
                <div class="col-6 my-auto">
                    <span class="dash-label text-uppercase">{{'TRANSFERS' | translate}}</span><br>
                    <span class="dash-small-numeric">{{eventSummary.get('Transfer') | roundNumber}}</span>
                </div>
                <div class="col-6 my-auto">
                    <span class="dash-label text-uppercase">{{'OTHERS' | translate}}</span><br>
                    <span class="dash-small-numeric">{{eventSummary.get('Others') | roundNumber}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <h4><span class="text-uppercase title-label" id="footer-center">{{ 'EVENTS' | translate}}</span>&nbsp;
            <span style="display: inline-flex">
                <div kendoTooltip position="bottom" class="keyboard-accessible" tabindex="0" showOn="none"
                    (focus)="showTooltip(eventsTooltip)" (mouseover)="showTooltip(eventsTooltip)" (blur)="hideTooltip()"
                    (mouseout)="hideTooltip()" aria-live="polite">
                    <a #eventsTooltip title="{{limitEventsText}}"><i class="fa fa-info-circle pointer" role="button"
                            attr.aria-label="{{ 'EVENTS' | translate}}"></i>
                    </a>
                </div>
            </span>
        </h4>
    </div>
</div>